<template>
  <div>
    <v-btn
      class="smButton"
      v-for="sm in links"
      :key="sm.url"
      :href="sm.url"
      icon
      fab
      small
      target="_blank"
      light
    >
      <v-icon>fab {{sm.icon}}</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      links: [
        {
          url: "https://open.spotify.com/artist/28T3p9vKAMe4OpNT2KhlN7",
          icon: "fa-spotify"
        },
        {
          url: "https://music.apple.com/album/trust-and-let-go-ep/1464683848",
          icon: "fa-itunes-note"
        },
        {
          url: "https://www.facebook.com/yazzminmusic",
          icon: "fa-facebook-f"
        },
        {
          url: "https://instagram.com/yazzkimo",
          icon: "fa-instagram"
        },
        {
          url: "https://www.youtube.com/channel/UCoj5y2YOaVnXvi1b6-hbKMw",
          icon: "fa-youtube"
        },
        {
          url: "https://www.youtube.com/watch?v=yubwGSUnOH0",
          icon: "fas fa-video"
        }
      ]
    };
  }
};
</script>

<style scoped>
.smButton {
  background-color: rgb(230, 230, 230);
}
</style>
